module.exports = __webpack_public_path__ + "media/images/plans/plan-icon-bouquet-3261e847cd9b243ee3c01c1036106154.png";